<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/obUTYc/tc-custom/9781625844101.jpg?1704761281346" alt="This image is the cover for the book Haunted Hills, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted Hills, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The author of <i>Wicked Charlotte</i> roots out the spirited secrets of two small towns deep in the Appalachian Mountains.</b><br/>  <br/> When the sun slips behind the trees and shadows lengthen near dusk, the mountains and valleys of Highlands and Cashiers whisper their tales of lost loves, deals gone bad, and ghosts who walk the night.<br/><br/><br/> This tourist destination is rich in folklore and legend—from rumors of a magical mountain volcano to the ghost of a white owl. Learn the stories and firsthand accounts of hauntings and the hard to explain. Listen to the voices winding through the hemlocks, or is it just the wind?<br/>  <br/> Includes photos!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephanie Burt Williams
      </h2>
      
      <p class="authorDescription body article">Stephanie Burt Williams, an assistant editor for The Post and Courier and a former staff writer for The Highlander, has published two books focusing on ghost stories including Wicked Charlotte. Through this experience in newspapers, she brings a journalistic style to these ghost stories.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Haunted America
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?389fe65d